<template lang="pug">

  div

    //- .sosLoginBlock(:class="{ 'bounce-animation': isBouncing }" @animationend="bouncingAnimationStopped")
    .sosLoginBlock(:class="{ 'bounce-animation': isBouncing }")
      input(v-if="autofocus" ref="sosLoginInput" :name="name" :type="type" :autofocus="true" @input="onInput" :value="value" :maxlength="maxLength" :placeholder="placeholder" :class="{ 'sosLoginField--filled': String(value).length > 0, 'sosLoginField--error': showError }" :disabled="disabled").sosLoginField
      input(v-else ref="sosLoginInput" :name="name" :type="type" @input="onInput" :value="value" :maxlength="maxLength" :placeholder="placeholder" :class="{ 'sosLoginField--filled': String(value).length > 0, 'sosLoginField--error': showError }" :disabled="disabled").sosLoginField
      sos-button(v-if="showButton" @buttonClick="buttonClick" size="small" color="white" buttonLabel="" :buttonIcon="buttonIcon" buttonIconSize="24" :disabled="buttonDisabled" rounded).sosLoginField--clearButton

    .sosLoginFieldErrorBlock(v-if="showError")
      p(v-for="errorMessage in fieldErrors" style="padding: 0; margin: 0" v-html="errorMessage")

    .sosLoginFieldSuccessBlock(v-if="showSuccess")
      p(style="padding: 0; margin: 0" v-html="showSuccess")

</template>

<script>

  import SosButton from '@/components/SosButton'

  const formatPhone = tel => {
    let maskedPhone = String(tel).trim().replace(/[^0-9]/g, '')

    const lPhone = maskedPhone.length

    maskedPhone = maskedPhone.replace(/^(\d\d)(\d)/g, '($1) $2')

    if (lPhone > 10) {
      maskedPhone = maskedPhone.replace(/(\d{5})(\d)/, '$1-$2').slice(0, 15)
    } else {
      maskedPhone = maskedPhone.replace(/(\d{4})(\d)/, '$1-$2').slice(0, 14)
    }

    return maskedPhone
  }

  export default {
    name: 'SosLoginField',

    components: {
      'sos-button': SosButton,
    },

    props: {
      // Leitura de v-model no VUE 2 (?)
      value: { type: String, required: true },

      autofocus: { type: Boolean, default: () => false },
      name: { type: String, default: () => '' }, // JESUS: Tratar campo de senha sem NAME
      type: { type: String, default: () => '' },
      maxLength: { type: Number, default: () => 0 }, // JESUS: Tratar
      placeholder: { type: String, default: () => '' },
      showSuccess: { type: String, default: () => '' },
      showError: { type: Boolean, default: () => false },
      fieldErrors: { type: Array, default: () => [] },
      disabled: { type: Boolean, default: () => false },
      showButton: { type: Boolean, default: () => false },
      buttonIcon: { type: String, default: () => '' },
      buttonDisabled: { type: Boolean, default: () => false },

      mask: { type: String, default: () => '' },
    },

    data() {
      return {
        isBouncing: false, // Controle interno da animação
      }
    },

    methods: {
      /* bouncingAnimationStopped () {
        this.isBouncing = false

        // [24/01/25] console.log('event bouncingAnimationStopped')
      }, */

      triggerBounce () {
        if (this.isBouncing === true) return false

        this.isBouncing = false // Remove a classe

        this.$nextTick(() => {
          // Reaplica a classe após o próximo ciclo de renderização
          this.isBouncing = true

          // Redundância caso o "animationend" não funcione)
          setTimeout(() => {
            this.isBouncing = false
            // [24/01/25] console.log('timeout bouncingAnimationStopped')
          }, 800)
        })
      },

      onInput (event)
      {
        if (this.mask === 'phone')
        {
          const formattedValue = formatPhone(event.target.value)

          this.$emit('input', formattedValue)

          // Atualiza o valor exibido no campo
          event.target.value = formattedValue
        }
        else
        {
          this.$emit('input', event.target.value)
        }
      },

      buttonClick ()
      {
        this.$emit('buttonClick')
      },

      onFocus ()
      {
        this.$nextTick(() => { this.$refs.sosLoginInput.scrollTop = 0 })
        this.$refs.sosLoginInput.focus()
      },
    },
  }

</script>
